<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item
        ><router-link to="/">首页</router-link></el-breadcrumb-item
      >
      <el-breadcrumb-item>测评题目</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <el-form
        inline
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="selClick"
      >
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick">查询</el-button>
          <el-button type="success" @click="addClick">新增</el-button>
        </el-form-item>
      </el-form>
      <el-card class="box-card table">
        <div slot="header"><span>题目列表</span></div>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column
            prop="title"
            label="名称"
            min-width="60"
          ></el-table-column>
          <el-table-column
            prop="sort"
            label="排序"
            width="70"
          ></el-table-column>

          <el-table-column label="是否可用" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isEnable" type="success">是</el-tag>
              <el-tag v-else type="info">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            width="70"
          ></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top:20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total,prev,sizes,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <el-dialog
      :title="form.id > 0 ? '编辑题目' : '添加题目'"
      :visible.sync="dialogVisible"
      width="700px"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        @submit.native.prevent="submitForm"
      >
        <el-form-item
          label="标题"
          prop="title"
          :rules="[{ required: true, message: '请输入标题' }]"
        >
          <el-input v-model="form.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item
          label="选项"
          prop="selectone"
          :rules="[{ required: true, message: '请输入选项', trigger: 'blur' }]"
        >
          <el-input
            v-model="form.selectone"
            placeholder="请输入选项，多个选项用 | 隔开"
            @input="optionChange"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-for="(item, index) in form.optionCategories"
          :key="index"
          :label="`选项${index + 1}分类`"
          :prop="`optionCategories.${index}.cateIds`"
          :rules="[
            {
              type: 'array',
              required: true,
              min: 1,
              message: '请至少选择一个分类',
              trigger: 'change',
            },
          ]"
        >
          <div class="option-category-row">
            <div class="option-name">{{ item.name }}</div>

            <el-select
              v-model="item.cateIds"
              multiple
              clearable
              filterable
              placeholder="请选择该选项对应的分类"
              style="width: 100%;"
            >
              <el-option
                v-for="category in catelist"
                :key="category.id"
                :label="category.title+category.code"
                :value="category.id"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item
          label="分数"
          prop="score"
          :rules="[{ required: true, message: '请输入分数', trigger: 'blur' }]"
        >
          <el-input
            v-model="form.score"
            placeholder="请输入分数，多个分数用 | 隔开"
          ></el-input>
        </el-form-item>

        <el-row :gutter="16">
          <el-col :span="8"
            ><el-form-item label="排序" :rules="[{ required: true }]"
              ><el-input
                v-model.number="form.sort"
                placeholder="请输入排序"
              ></el-input></el-form-item
          ></el-col>

          <el-col :span="8"
            ><el-form-item label="启用" :rules="[{ required: true }]"
              ><el-switch v-model="form.isEnable"></el-switch></el-form-item
          ></el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      key: "",
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      submiting: false,
      form: this.createEmptyForm(),
      catelist: [],
    };
  },
  created() {
    this.GetAllCategory();
    this.getList();
  },
  methods: {
    createEmptyForm() {
      return {
        id: 0,
        evaluationID: "",
        title: "",
        selectone: "",
        score: "",
        cateid: "",
        sort: 0,
        isEnable: true,

        // 页面使用，提交时删除
        optionCategories: [],
      };
    },

    /**
     * 输入选项时生成对应的分类多选框
     */
    optionChange() {
      const optionNames = this.getOptionNames(this.form.selectone);
      const oldOptions = this.form.optionCategories || [];

      const newOptions = optionNames.map((name, index) => {
        // 优先根据选项名称保留之前选择的分类
        const sameNameItem = oldOptions.find((item) => item.name === name);

        if (sameNameItem) {
          return {
            name,
            cateIds: Array.isArray(sameNameItem.cateIds)
              ? sameNameItem.cateIds.slice()
              : [],
          };
        }

        // 名称改变时，尝试根据位置保留
        const sameIndexItem = oldOptions[index];

        return {
          name,
          cateIds:
            sameIndexItem && Array.isArray(sameIndexItem.cateIds)
              ? sameIndexItem.cateIds.slice()
              : [],
        };
      });

      this.$set(this.form, "optionCategories", newOptions);
    },

    /**
     * 将选项字符串转成数组
     */
    getOptionNames(selectone) {
      return String(selectone || "")
        .split("|")
        .map((item) => item.trim())
        .filter((item) => item !== "");
    },

    /**
     * 编辑时把 Cateid 字符串还原成多选数组
     *
     * 例如：
     * selectone = A|B|C
     * cateid = 1,2;3;4,5
     */
    parseOptionCategories(selectone, cateid) {
      const optionNames = this.getOptionNames(selectone);

      const categoryGroups = String(cateid || "").split(";");

      return optionNames.map((name, index) => {
        const categoryText = categoryGroups[index] || "";

        const cateIds = categoryText
          .split(",")
          .map((item) => item.trim())
          .filter((item) => item !== "")
          .map((item) => Number(item))
          .filter((item) => !Number.isNaN(item));

        return {
          name,
          cateIds,
        };
      });
    },

    api(a) {
      return url.getMiniCategoryAndStudyPlan(a);
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    changes() {
      let list = this.form.selectone.split("|");
      this.select = list.map((x) => {
        return { name: x, cateXid: "" };
      });
      console.log(this.select);
    },
    selClick() {
      this.currentPage = 1;
      this.getList();
    },
    GetAllCategory: function() {
      var _this = this;
      var link = this.api("GetAllCategory");
      $.get(link, {}, (res) => {
        _this.catelist = res;
      });
    },
    getList() {
      this.loading = true;
      $.get(
        this.api("GetList_Qusetion"),
        {
          key: this.key,
          pageindex: this.currentPage,
          pagesize: this.pageSize,
        },
        (data) => {
          this.loading = false;
          this.tableData = data.list;
          this.total = data.total;
        }
      );
    },
    addClick() {
      this.form = this.createEmptyForm();
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    editClick(row) {
      const formData = Object.assign(this.createEmptyForm(), row);

      // 兼容后端返回 Cateid 或 cateid
      const cateid = row.cateid || row.Cateid || "";

      formData.cateid = cateid;
      formData.optionCategories = this.parseOptionCategories(
        formData.selectone,
        cateid
      );

      this.form = formData;
      this.dialogVisible = true;

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },

    delClick(row) {
      this.$confirm("确定删除？", "提示", { type: "warning" })
        .then(() => {
          $.post(this.api("Delete_Question"), { id: row.id }, (res) => {
            if (res.status) {
              this.getList();
              this.$message.success(res.msg);
            } else this.$message.error(res.msg);
          });
        })
        .catch(() => {});
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const optionNames = this.getOptionNames(this.form.selectone);
        const optionCategories = this.form.optionCategories || [];

        if (optionNames.length === 0) {
          this.$message.warning("请至少输入一个选项");
          return;
        }

        if (optionNames.length !== optionCategories.length) {
          this.$message.warning("选项和分类数量不一致，请重新输入选项");
          return;
        }

        const hasEmptyCategory = optionCategories.some(
          (item) => !Array.isArray(item.cateIds) || item.cateIds.length === 0
        );

        if (hasEmptyCategory) {
          this.$message.warning("每个选项至少需要选择一个分类");
          return;
        }

        // 表结构中 Score 使用分号分隔
        const scoreList = String(this.form.score || "")
          .split("|")
          .map((item) => item.trim())
          .filter((item) => item !== "");

        if (scoreList.length !== optionNames.length) {
          this.$message.warning(
            `当前有 ${optionNames.length} 个选项，请填写 ${optionNames.length} 个分数，并使用|分隔`
          );
          return;
        }

        const info = Object.assign({}, this.form);

        // 统一整理选项字符串
        info.selectone = optionNames.join("|");

        // 每个选项内部用逗号，选项之间用分号
        info.cateid = optionCategories
          .map((item) => item.cateIds.join(","))
          .join(";");

        // 统一整理分数字符串
        info.score = scoreList.join("|");

        // 只用于前端页面，不发送给后端
        delete info.optionCategories;
        this.submiting = true;
        $.post(this.api("Save_Question"), info, (res) => {
          this.submiting = false;
          if (res.status) {
            this.dialogVisible = false;
            this.getList();
            this.$message.success(res.msg);
          } else this.$message.error(res.msg);
        });
      });
    },
  },
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.option-category-row {
  width: 100%;
}

.option-name {
  margin-bottom: 8px;
  padding: 6px 10px;
  line-height: 20px;
  color: #606266;
  background: #f5f7fa;
  border-radius: 4px;
  word-break: break-all;
}
</style>
